import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import Grid from '@mui/material/Grid2';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { ui } from "../../../interfaces/interfaces";
import useDebugInformation from "../../../hooks/useDebugInformation";
import { cacheUtils } from "../../..";
import { CacheTypes } from "@utils/cache/interfaces";
import { serviceManager } from "@services/workers";
import { useAppSelector } from "@store/hooks";

type Props = {}

const AgentsDialog: React.FC<Props> = () => {
    const agentsModal = useAppSelector(({ ui }) => ui.AgentsModal)
    const comboAgent = useAppSelector(({ ui }) => ui.ComboAgent)

    const handleClose = () => {
        ui.AgentsModal = false
    };

    const handleSave = () => {
        ui.AgentsModal = false
    };

    const handleChange = (event: any, value: any) => {
        ui.ComboAgent = value
        serviceManager.sendMessageToWorker({
            serviceName: "PUZZEL_SYNC",
            serviceData: {
                command: "MONITOR_USER",
                payload: value?.agent_id ?? null,
                origin: "MAIN_THREAD",
            }
        })
    };

    useDebugInformation("AgentsDialog", { agentsModal, comboAgent })
    return (
        (<div>
            <Dialog open={agentsModal} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="xl">
                <DialogTitle id="form-dialog-title">Select agent to follow</DialogTitle>
                <DialogContent>
                    <DialogContentText>Required questions:</DialogContentText>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 12
                        }}>
                        <Autocomplete
                            id="combo-box-Agents"
                            fullWidth
                            // displayEmpty
                            options={cacheUtils.getCache<CacheTypes.Agents>("Agents").filter(x => !x.deleted)}
                            getOptionLabel={(options) => `${options.full_name}[${options.agent_id}]`}
                            onChange={handleChange}
                            isOptionEqualToValue={(option, value) => option?.agent_id === value?.agent_id}
                            renderInput={(params) => <TextField {...params} label="Agents" variant="outlined" />}
                            value={comboAgent || null}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSave} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>)
    );
}

export default React.memo(AgentsDialog)